var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-view"},_vm._l((_vm.tags),function(tag,tagIndex){return _c('div',{key:tagIndex,staticClass:"tag"},[_vm._v(_vm._s(tag))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }